let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hzxqv")).then(() => parcelRequire('3dWFS'));